import styled from "styled-components";
import { colors } from "styles";

const LOGO = `https://www.creditrocket.me/wp-content/uploads/2022/05/cp720-logo.png`;

const ServiceProvider = () => {
  return (
    <div>
      <Text>Servicio por:</Text>
      <img src={LOGO} alt="CP720" width={75} />
    </div>
  );
};

export default ServiceProvider;

const Text = styled.div`
  color: ${colors.black};
  opacity: 0.6;
  font-size: 0.8em;
  padding-bottom: 5px;
`;
